import React, { useEffect, useState } from "react";
import { getWithExpiry } from "../../../Domain/Helpers/LocalStorageHelper";
import { getTransactionById } from "../../../Infrastructure/Services/TransactionService";
import { toast } from "react-toastify";
import { createdUpdatedAtValueFormat, formatColumnNames } from "../../../Domain/Helpers/StringFormatHelper";
import { displayNestedValues } from "../../../Domain/Helpers/DisplayHelper";

function TransactionDetailsPage(props) {
    const [data, setData] = useState(null);
    const [notFound, setNotFound] = useState(false);

    const loadData = () => {
        var token = getWithExpiry("token");

        if (token === null) {
            props.setLoggedIn(false);
            return;
        }

        const search = window.location.search;
        const params = new URLSearchParams(search);
        let id = params.get('id');
        getTransactionById(id, token).then((data) => {
            if (data === null) {
                setNotFound(true);
            } else {
                setData(data);
            }
        }).catch((ex) => {
            toast.error(ex);
            setNotFound(true);
        })
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <>
            <div className="d-flex justify-content-between mt-2">
                <p className="h3">Transaction Details</p>
            </div>

            <div className="mt-2">
                {notFound &&
                    <p className="text-danger h4">Transaction not found</p>
                }

                {
                    !notFound && data &&
                    <>
                        <ul className="list-group">
                            {Object.entries(data).map((entry, index) => {
                                return <React.Fragment key={index}>
                                    {
                                        (!entry[0].includes("_id") ||(props.displayIds && props.displayIds.includes(entry[0]))) && 
                                        ((props.manyToManyRelations && props.manyToManyRelations.filter(x => x.name === entry[0]).length === 0) || !props.manyToManyRelations) &&
                                        ((props.oneToManyRelations && props.oneToManyRelations.filter(x => x.name === entry[0]).length === 0) || !props.oneToManyRelations)
                                        && <li className="list-group-item d-flex justify-content-between align-items-start" key={index}>
                                            <div className="ms-2 me-auto w-100">
                                                <span className="fw-bold me-2">{formatColumnNames(entry[0])}:</span>
                                                {!entry[1] ? "/" : typeof (entry[1]) !== "object" ? <>{entry[0] === "created_at" || entry[0] === "updated_at" ? createdUpdatedAtValueFormat(entry[1]) : isNaN(Number(entry[1])) ? entry[1].toString() : Number(entry[1])}</> : entry[1] &&
                                                    displayNestedValues(entry[1], index)
                                                }
                                            </div>
                                        </li>
                                    }
                                </React.Fragment>
                            })}
                        </ul>
                    </>
                }
            </div>
        </>
    )
}

export default TransactionDetailsPage;